import { render } from "./MatchGround.vue?vue&type=template&id=0c3acfad&scoped=true"
import script from "./MatchGround.vue?vue&type=script&lang=js"
export * from "./MatchGround.vue?vue&type=script&lang=js"

import "./MatchGround.vue?vue&type=style&index=0&id=0c3acfad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3acfad"]])

export default __exports__